import React, { useState } from 'react'
import useFetch from '../../Services/useFetch'

import { Button, Row, Col } from 'reactstrap';
import { endpoints } from '../../utils/Constants';
import { Input } from 'reactstrap'
import { useEffect } from 'react';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useAlert } from '../../Services/AlertContext';
import RichTextEditor from '../Form/RichTextEditor';
import SelectSettingNoForm from '../Form/SelectSettingNoForm';
import useFetchSimple from '../../Services/useFetchSimple';
import { base64Encode } from '../../utils/Helpers';
const ManageTermsAndConditions = () => {
    const [termsName, setTermsName] = useState();
    const [template, loadingTemplate, errorTemplate] = useFetch(termsName ? endpoints.getTermsAndConditions + '/' + termsName : null);
    const [updated, setUpdated] = useState();
    const [newLabel, setNewLabel] = useState();
    const [saving, setSaving] = useState();
    const [changed, setChanged] = useState();
    const [newItem, setNewItem] = useState();
    const fetch = useFetchSimple();
    const alert = useAlert();
    useEffect(() => { loadingTemplate && !saving && setUpdated() }, [saving, loadingTemplate])

    const templateSelected = (item) => {
        setTermsName(item);
        setNewLabel();
        setNewItem();
    }
    const saveTerms = async () => {
        let requestBody = JSON.stringify({ ...template, label: newLabel, terms: updated, });
        requestBody = JSON.stringify({ encodedData: base64Encode(requestBody) });
        const options = { method: 'POST', body: requestBody };
        setSaving(true);
        setChanged(false);
        try {
            var result = await fetch(endpoints.saveTerms, options);
            const ret = result.body;
            if (ret.success) {
                const m = ret.messages;
                alert({

                    title: <div>
                        <h5>{newItem ? "New Template" : "Updated Template"}</h5>
                        {m && m.length ? m.map(x => <p>{x}</p>) : "Saved OK"}
                    </div>
                    , onDismiss: () => {
                        setSaving(false);
                        setChanged(false);
                        setUpdated(false);
                        setNewItem();

                    }
                });
            }
            else {
                alert({

                    title: "Error", body: <div>
                        <h5>Error saving template</h5>
                        {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {

                        setSaving(false);

                    }
                });

            }
        }
        catch (e) {
            alert({

                title: "Error", body: JSON.stringify(e)
                , onDismiss: () => {

                    setSaving(false);

                }
            });
        }

    }
    const onchanged = (e) => {
        setUpdated(e);

    }
    const onChangedLabel = (e) => {
        setNewLabel(e.target.value);
    }
    useEffect(() => {
        if (!changed && updated && template && updated !== template.value) {
            setChanged(true);
        }
    }, [changed, updated, template]);
    return <React.Fragment>
        <SelectSettingNoForm endpoint={endpoints.getTermsAndConditionsTypes} onChange={templateSelected} />
        {errorTemplate ? <h6>Error loading template</h6> : null}
        {loadingTemplate ? <LoadingAnimation /> :
            <React.Fragment> <Row>
                <Col>
                    {termsName ? <RichTextEditor value={template?.terms} onChange={onchanged} /> : null}
                </Col>
            </Row>
                <Row>
                    <Col>
                        {termsName ? <Input value={template?.label} onChange={onChangedLabel} /> : null}
                    </Col>
                </Row>
            </React.Fragment>}

        {changed || newItem ? <Button onClick={saveTerms}>Save</Button> : null}

    </React.Fragment>

}

export default ManageTermsAndConditions;